import * as React from 'react';
import { cn } from 'src/app/lib/utils/tailwindcss';

export type BaseInputProps = React.ComponentProps<'input'>;

const BaseInput = React.forwardRef<HTMLInputElement, BaseInputProps>(({ className, type, ...props }, ref) => {
  return <input ref={ref} type={type} data-slot="input" className={cn('text-g-90', className)} {...props} />;
});

BaseInput.displayName = 'BaseInput';

export default BaseInput;
